export enum ConfirmationDialogResult {
  CONFIRMED = 'confirmed',
  CANCELED = 'canceled',
}
